import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { Paper, styled, TableCell, tablePaginationClasses, TableRow } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const TableCellStyled = styled(TableCell)(({ theme }) => ({
  color: 'white',
  padding: '1rem 3rem',
  width: '30%',
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
}));

export const OnlineTableCell = styled(TableCell)(({ theme, width }) => ({
  color: 'white',
  padding: '1rem 3rem',
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
}));

export const TableCellGroup = styled(TableCellStyled)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const OnlineTableCellGroup = styled(OnlineTableCell)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const StatusTableCellGroup = styled(OnlineTableCell)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const StatusContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
  alignItems: 'center',
}));

export const TableRowName = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
}));

export const EditIcon = styled(CreateOutlinedIcon)(() => ({
  cursor: 'pointer',
  display: 'flex',
  paddingBottom: '0.5rem',
}));

export const TableRowStyled = styled(TableRow)(() => ({
  cursor: 'pointer',
}));

export const TablePaginationStyles = {
  color: theme.palette.common.white,
  borderTop: `.06rem solid ${theme.palette.common.white}`,
  background: theme.palette.primary.main,

  [`& .${tablePaginationClasses.select}:focus`]: {
    backgroundColor: 'transparent',
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    color: theme.palette.common.white,
  },
};

export const AlignStatusContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.25rem',
}));

export const TableMobilePaginationStyles = {
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  fontSize: '0.875rem',
  marginBottom: '4.5rem',
  overFlowX: 'hidden',

  svg: {
    zIndex: '1',
  },

  [`& .${tablePaginationClasses.toolbar}`]: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: '0.5rem 1rem',
  },

  [`& .${tablePaginationClasses.actions}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '0px',
  },

  [`& .${tablePaginationClasses.selectLabel}`]: {
    color: theme.palette.common.white,
    margin: '0.25rem 0',
  },

  [`& .${tablePaginationClasses.displayedRows}`]: {
    color: theme.palette.common.white,
    position: 'absolute',
    bottom: '0.75rem',
    right: '50%',
    transform: 'translateX(50%)',
    flexBasis: '100%',
    alignItems: 'center',
    margin: '0.25rem 0',
  },

  [`& .${tablePaginationClasses.select}`]: {
    color: theme.palette.common.white,
    paddingRight: '2rem',
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    color: theme.palette.common.white,
  },
};

export const BoxCustom = styled('div')(() => ({
  marginBottom: '2rem',
}));
